import React from "react";
import Link from "@mui/material/Link";
import { getMeaning } from "../../utils/localization";
import PPBANNER from "../../assets/PrivacyPolicy.png";
import GlobalBanner from "../../components/GlobalBanner";
import { Box, Paper, Divider, Typography } from "@mui/material";

const CustomerAppPolicy = () => {
  return (
    <div>
      <Box sx={{ flex: 1 }}>
        <GlobalBanner backgroundImage={PPBANNER} />
      </Box>

      <Box sx={{ py: 5 }}>
        <Paper elevation={0} sx={{ px: 5 }}>
          <>
            <Typography variant="h3" gutterBottom sx={styles.PPHeadingTxt}>
              {getMeaning("CPP.PP")}
            </Typography>

            <Typography variant="body2" gutterBottom sx={styles.LabelTxt}>
              {getMeaning("CPP.EFCTDTE")}
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2" gutterBottom sx={styles.LabelTxt}>
                {getMeaning("CPP.APPNAMELABEL")}
              </Typography>

              <Typography variant="body2" gutterBottom sx={styles.LabelTxt}>
                {getMeaning("CPP.APPNAMEVALUE")}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2" gutterBottom sx={styles.LabelTxt}>
                {getMeaning("CPP.OWNBYLABEL")}
              </Typography>

              <Typography variant="body2" gutterBottom sx={styles.LabelTxt}>
                {getMeaning("CPP.OWNBYVALUE")}
              </Typography>
            </Box>
          </>

          <Divider sx={{ my: 3 }} />

          {/* 1. Introduction */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.INTROLBL")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("CPP.INTRODSCP")}
            </Typography>
            <Typography variant="body1" sx={[styles.LabelTxt, { mt: 1 }]}>
              {getMeaning("CPP.INTRODSCPTWO")}
            </Typography>
          </Box>

          {/* 2. Information We Collect */}
          <Box sx={{ mb: 0 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.INFOWECOLLECTLBL")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("CPP.INFOWECOLLECTDSCP")}
            </Typography>
          </Box>

          {/* 2.1 Personal Information */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.PRSNLINFOLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PRSNLINFONAME")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PRSNLINFOEMAIL")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PRSNLINFOMOBILE")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PRSNLINFOALTMOBILE")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PRSNLINFOACTIVATIONID")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PRSNLINFODEVICEINFO")}
              </Typography>
            </Box>
          </Box>
          {/* 2.2 Policy & Plan Information */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.PLCYPLNLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PLCYPLNSELPLNDTLS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PLCYPLNPRCHSEPLNDTLS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PLCYPLNPLCYDOCSREL")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletSubDescpTxt}>
                {getMeaning("CPP.PLCYPLNEW")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletSubDescpTxt}>
                {getMeaning("CPP.PLCYPLNMP")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletSubDescpTxt}>
                {getMeaning("CPP.PLCYPLNTP")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletSubDescpTxt}>
                {getMeaning("CPP.PLCYPLNLP")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletSubDescpTxt}>
                {getMeaning("CPP.PLCYPLNCP")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletSubDescpTxt}>
                {getMeaning("CPP.PLCYPLNPM")}
              </Typography>
            </Box>
          </Box>
          {/* 2.3 Claim Information */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.CLMINFOLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.CLMINFOCLMSLST")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.CLMINFOLBLCLMSTATUS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.CLMINFOLBLINITIATECLMDTLS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.CLMINFOUPLOADDOCVIDEO")}
              </Typography>
            </Box>
          </Box>
          {/* 2.4 Diagnostic & Device Test Data */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.DIAGNOSEDEVICELBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.DIAGNOSEFRNTCAMRA")}
              </Typography>

              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.DIAGNOSEMIC")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.DIAGNOSESPEAKER")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.DIAGNOSEGPS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.DIAGNOSEBATTERYHEALTH")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.DIAGNOSEMOBILESCREEN")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.DIAGNOSEDEVICECHARNING")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.DIAGNOSEDEVICEDSCPTWO")}
              </Typography>
            </Box>
          </Box>
          {/* 2.5 Media & File Upload Information */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.MEDIAUPLOADLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.MEDIAUPLOADDSCP")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.MEDIAVIDEOUPLOAD")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.MEDIAUPLOADFILE")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.MEDIAUPLOADSCREENSHOTS")}
              </Typography>
            </Box>
          </Box>
          {/* 2.6 Automatic Data Collection */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.AUTODATACOLLECTLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.AUTODATACOLLECTDSCP")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.AUTOCOLLECTIP")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.AUTOCOLLECTDEVICEDETAILS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.AUTOCOLLECTAPPVERSION")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.AUTOCOLLECTUSAGEANALYTICS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.AUTOCOLLECTCRASHLOGS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.AUTODATACOLLECTDSCPTWO")}
              </Typography>
            </Box>
          </Box>

          {/* 3 How We Use Your Information */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.HOWWEUSEINFOLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.HOWWEUSEINFODSCP")}
              </Typography>
            </Box>
          </Box>
          {/* 3.1 To Provide and Manage Your Plans */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.HOWWEUSEPROVIDEMANAGEPLAN")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.HOWWEUSEDISPLAYPLAN")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.HOWWEUSESHOWPLANDTLS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.HOWWEUSEENABLEPRCHSEPLN")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.HOWWEUSEDISPLAYUSERPOLICY")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.HOWWEUSEVIEWACTIVATIONDTLS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.HOWWEUSEMANAGEPOLICYUPDATES")}
              </Typography>
            </Box>
          </Box>
          {/* 3.2 To Process Claims */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.TOPROCESSCLAIMSLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.TOPROCESSDISPLAYALLCLAIMS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.TOPROCESSINITIATECLAIMS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.TOPROCESSDIAGNOSTICS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.TOPROCESSVALIDATEDEVICE")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.TOPROCESSVIDEOVERIFICATION")}
              </Typography>
            </Box>
          </Box>
          {/* 3.3 To Communicate With You */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.TOCOMMUNICATELABL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.TOCOMMUNICATESENDSMS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.TOCOMMUNICATEUPDATEONPOLICY")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.TOCOMMUNICATESUPPORTQUERY")}
              </Typography>
            </Box>
          </Box>
          {/* 3.4 To Improve App Experience */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.TOIMPROVEAPPEXPERIENCELBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.TOIMPROVEAPPENHANCEUIUX")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.TOIMPROVEAPPBUGFIX")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.TOIMPROVEAPPPERFORMANCE")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.TOIMPROVEAPPSECURITY")}
              </Typography>
            </Box>
          </Box>

          {/* 4 How We Share Your Information */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.SHAREINFOLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.SHAREINFOLBLDSCPONE")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.SHAREINFOLBLDSCPTWO")}
              </Typography>
            </Box>
          </Box>
          {/* 4.1 Service Providers */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.SERVICEPROVIDERLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.SERVICEPROVIDERDSCP")}
              </Typography>
            </Box>
          </Box>
          {/* 4.2 Insurance or Warranty Partners */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.WARRANTYPARTNERLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.WARRANTYPARTNERDSCP")}
              </Typography>
            </Box>
          </Box>
          {/* 4.3 Legal Requirements */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.LEGALREQUIREMENTSLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.LEGALREQUIREMENTSDSCP")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.LEGALREQUIREMENTCOURTORDER")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.LEGALREQUIREMENTGOVAUTHORITIES")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.LEGALREQUIREMENTLEGALINVESTIGATION")}
              </Typography>
            </Box>
          </Box>

          {/* 5. Data Storage & Security */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.STORAGESECURITYLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.STORAGESECURITYDSCP")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.STORAGESECURITYENCRYPTDATA")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.STORAGESECURITYSECURESTORAGE")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.STORAGESECURITYROLEACCESS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.STORAGESECURITYSECURITYAUDITS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.STORAGESECURITYINFODSCP")}
              </Typography>
            </Box>
          </Box>

          {/* 6. Your Rights */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.YOURIGHTSLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.YOURIGHTSDSCP")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.YOURIGHTSACCESSDATA")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.YOURIGHTSREQCORRECT")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.YOURIGHTSREQDELETE")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.YOURIGHTSWITHDRAWCONSENT")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.YOURIGHTSDOWNLOADDATACOPY")}
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="body1" sx={styles.BulletDescpTxt}>
                  {getMeaning("CPP.YOURIGHTSSUPPORTDESCPONE")}
                </Typography>
                <Typography
                  variant="body1"
                  sx={[styles.BulletDescpTxt, { ml: 0, fontWeight: "600" }]}
                >
                  {getMeaning("CPP.YOURIGHTSSUPPORTDESCPTWO")}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* 7. Permissions We Require */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.PERMISSIONREQUIRELBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PERMISSIONREQUIREDSCP")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PERMISSIONREQUIREFORCAMERA")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PERMISSIONREQUIREFORMIC")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PERMISSIONREQUIREFORSTORAGE")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PERMISSIONREQUIREFORVIDEOREC")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PERMISSIONREQUIREFORGPS")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.PERMISSIONREQUIREDESCPTWO")}
              </Typography>
            </Box>
          </Box>

          {/* 8. Children’s Privacy */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.CHILDPRIVACY")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.CHILDPRIVACYDESCPONE")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.CHILDPRIVACYDESCPTWO")}
              </Typography>
            </Box>
          </Box>

          {/* 9. Third-Party Services Used */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.THIRDPARTYSERVICELBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.THIRDPARTYSERVICEDSCP")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.THIRDPARTYSERVICESMSGATEWAY")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.THIRDPARTYSERVICECLOUDHOSTING")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.THIRDPARTYSERVICEDEVICEDIAGNOSE")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.THIRDPARTYSERVICEPAYMENTGATEWAY")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.THIRDPARTYSERVICEANALYTICSTOOL")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.THIRDPARTYSERVICEDSCPTWO")}
              </Typography>
            </Box>
          </Box>

          {/* 10. Changes to This Privacy Policy */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.CHANGESTOPOLICYLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.CHANGESTOPOLICYDESCPONE")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.CHANGESTOPOLICYDESCPTWO")}
              </Typography>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.CHANGESTOPOLICYDESCPTHREE")}
              </Typography>
            </Box>
          </Box>

          {/* 11. Contact Us */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("CPP.CONTACTUSLBL")}
            </Typography>
            <Box>
              <Typography variant="body1" sx={styles.BulletDescpTxt}>
                {getMeaning("CPP.CONTACTUSDESCP")}
              </Typography>

              <Box sx={{ mt: 0 }}>
                <Typography variant="body1" sx={styles.LabelTxt}>
                  <strong>Email:</strong>{" "}
                  <Link
                    href="mailto:contact@acrossassist.com"
                    underline="hover"
                  >
                    {getMeaning("CPP.CONTACTUSEMLVALUE")}
                  </Link>
                  <br />
                </Typography>
              </Box>

              <Box sx={{ mt: 0 }}>
                <Typography variant="body1" sx={styles.LabelTxt}>
                  <strong>{getMeaning("CPP.CONTACTUSWEBSITELBL")}</strong>{" "}
                  <Link
                    href="https://acrossassist.com"
                    underline="hover"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {getMeaning("CPP.CONTACTUSWEBSITEVALUE")}
                  </Link>
                  <br />
                </Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </div>
  );
};

export default CustomerAppPolicy;

const styles = {
  PPHeadingTxt: {
    color: "black",
    fontWeight: "600",
    fontSize: "1.2rem",
    fontFamily: '"Poppins", serif',
  },
  HeadingTxt: {
    color: "black",
    fontSize: "1.2rem",
    fontFamily: '"Poppins", serif',
  },
  SubHeadingTxt: {
    color: "black",
    fontSize: "1.05rem",
    fontFamily: '"Poppins", serif',
    fontWeight: "500",
  },
  BoldLabelTxt: {
    color: "black",
    fontSize: "0.9rem",
    fontFamily: '"Poppins", serif',
    fontWeight: "500",
  },
  LabelTxt: {
    color: "black",
    fontSize: "0.9rem",
    fontFamily: '"Poppins", serif',
  },
  BulletDescpTxt: {
    ml: 2,
    color: "black",
    fontSize: "0.91rem",
    fontFamily: '"Poppins", serif',
  },
  BulletSubDescpTxt: {
    ml: 5,
    color: "black",
    fontSize: "0.91rem",
    fontFamily: '"Poppins", serif',
  },
};
